export default { sha: 'c55dccad570d91c2c95681c1962872e736c45a43', buildNumber: 'undefined' }
